// Wishlist page — read the local store, fetch details from /api/inventory/by-ids.
// For now this renders just the saved IDs with a "Open original search" hint.
import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, X } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { useWishlist } from '../../lib/wishlist';

const Wishlist = () => {
  const { has, toggle } = useWishlist();
  const ids = (() => {
    try { return JSON.parse(localStorage.getItem('elite_wishlist') || '[]'); } catch { return []; }
  })();
  return (
    <div className="bg-gray-50 dark:bg-gray-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-1">My Wishlist</h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">Properties and trips you've saved for later.</p>

        {ids.length === 0 ? (
          <Card className="text-center py-12"><CardContent>
            <Heart className="h-10 w-10 text-gray-400 mx-auto mb-3" />
            <p className="font-semibold text-gray-900 dark:text-white">Your wishlist is empty</p>
            <p className="text-sm text-gray-500 mt-1">Tap the heart on any hotel to save it here for later.</p>
            <Link to="/hotels/search" className="inline-block mt-4 text-sm font-semibold text-red-600 hover:underline">Browse hotels →</Link>
          </CardContent></Card>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="wishlist-items">
            {ids.map((id) => (
              <Card key={id} data-testid={`wishlist-${id}`}>
                <CardContent className="p-4 flex items-center gap-3">
                  <div className="bg-red-50 p-2 rounded-lg"><Heart className="h-4 w-4 text-red-600 fill-current" /></div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-gray-900 dark:text-white text-sm truncate">{id}</p>
                    <p className="text-[11px] text-gray-500">Re-run your hotel search to view live pricing.</p>
                  </div>
                  <Button variant="ghost" size="sm" data-testid={`unwishlist-${id}`} onClick={() => toggle(id)} className="text-gray-500"><X className="h-4 w-4" /></Button>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Wishlist;
